export const CREATE_NEW = '<Create New>';
export const NONE = '<None>';
